// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oY-S","clinicsSelect":"styles_clinicsSelect__3fRkN"};